import { render, staticRenderFns } from "./SavedVehicleCard.vue?vue&type=template&id=0971124c"
import script from "./SavedVehicleCard.vue?vue&type=script&lang=ts"
export * from "./SavedVehicleCard.vue?vue&type=script&lang=ts"
import style0 from "./SavedVehicleCard.vue?vue&type=style&index=0&id=0971124c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports